<template>
  <div ref="adContainer" class="google-ads-banner">
    <!-- Banner Ad -->
    <ins
      ref="adElement"
      class="adsbygoogle"
      style="display:block; justify-self: center;"
      data-ad-client="ca-pub-2682842196395053"
      data-ad-slot="3446179195"
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins>
  </div>
</template>

<script>
export default {
  name: 'GoogleAdsBanner',
  data() {
    return {
      scriptLoaded: false,
      AdsId: '',
      ClientId: '',
      enableAds: false,
    };
  },
  mounted() {
    if (process.client) {
      this.loadGoogleAdsScript();
    }
  },
  methods: {
    loadGoogleAdsScript() {
      // Check if script is already loaded
      const existingScript = document.querySelector('script[src*="adsbygoogle.js"]');
      if (existingScript) {
        // Script already exists, initialize ad immediately
        this.$nextTick(() => {
          this.initializeAd();
        });
        return;
      }

      // Check if we're in browser environment
      if (typeof window !== 'undefined') {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2682842196395053';
        script.crossOrigin = 'anonymous';
        script.onload = () => {
          this.scriptLoaded = true;
          this.$nextTick(() => {
            this.initializeAd();
          });
        };
        // If script fails to load, still try to initialize (script might be cached)
        script.onerror = () => {
          this.$nextTick(() => {
            this.initializeAd();
          });
        };
        document.head.appendChild(script);
      }
    },
    initializeAd() {
      if (typeof window !== 'undefined') {
        try {
          // Ensure adsbygoogle array exists
          window.adsbygoogle = window.adsbygoogle || [];
          // Push the ad configuration
          window.adsbygoogle.push({});
        } catch (error) {
          console.error('Error initializing Google Ad:', error);
        }
      }
    },
  },
};
</script>

<style scoped>
.google-ads-banner {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100px;
  padding: 0 20px;
}

.google-ads-banner .adsbygoogle {
  width: 100% !important;
  max-width: 1200px !important;
  margin: 0 auto;
  display: block;
}

/* Ensure fixed dimensions on mobile - center the ad */
@media (max-width: 1240px) {
  .google-ads-banner {
    width: calc(100% - 40px);
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
  }
}

/* Very small screens - ensure ad doesn't overflow */
@media (max-width: 640px) {
  .google-ads-banner {
    width: calc(100% - 20px);
    padding: 0 10px;
  }
}
</style>

